/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { RouteConfigItem } from 'models';

function generateRouteID(key: string): string {
  const prefix =
    process.env.REACT_APP_STORAGE_PREFIX || '@portalservicos-digix';
  return `${prefix}:${key}`;
}

export const routesConfig: RouteConfigItem[] = [
  {
    id: generateRouteID('home'),
    path: '/',
    elementPath: 'Home',
    isPrivate: false,
    redirectPath: '/login',
  },
  {
    id: generateRouteID('login'),
    path: '/login',
    elementPath: 'Login',
    isPrivate: false,
  },
  {
    id: generateRouteID('definicaosenha'),
    path: '/definicaosenha',
    elementPath: 'DefinicaoSenha',
    isPrivate: false,
  },
  {
    id: generateRouteID('notificacoes'),
    path: '/fornecedores/notificacoes',
    elementPath: 'Notificacoes',
    routeTitle: 'Notificacoes',
    isPrivate: true,
  },
  {
    id: generateRouteID('reclamacoesVerificaGeolocalizacao'),
    path: '/reclamacoes',
    elementPath: 'ReclamacoesVerificarGeolocalizacao',
    isPrivate: false,
    redirectPath: process.env.REACT_APP_NOVO_PORTAL_URL || '/',
  },
  {
    id: generateRouteID('reclamacoesLogin'),
    path: '/reclamacoes/login',
    elementPath: 'ReclamacoesLogin',
    isPrivate: false,
    redirectPath: process.env.REACT_APP_NOVO_PORTAL_URL || '/',
  },
  {
    id: generateRouteID('reclamacoesPrimeiroAcesso'),
    path: '/reclamacoes/primeiro-acesso',
    elementPath: 'ReclamacoesPrimeiroAcesso',
    isPrivate: false,
    redirectPath: process.env.REACT_APP_NOVO_PORTAL_URL || '/',
  },
  {
    id: generateRouteID('reclamacoesEsqueciSenha'),
    path: '/reclamacoes/esqueci-senha',
    elementPath: 'ReclamacoesEsqueciSenha',
    isPrivate: false,
    redirectPath: process.env.REACT_APP_NOVO_PORTAL_URL || '/',
  },
  {
    id: generateRouteID('reclamacoesEsqueciSenha'),
    path: '/reclamacoes/definir-senha',
    elementPath: 'ReclamacoesDefinirSenha',
    isPrivate: false,
    redirectPath: process.env.REACT_APP_NOVO_PORTAL_URL || '/',
  },
  {
    id: generateRouteID('reclamacoesAcesso'),
    path: '/reclamacoes/acesso',
    elementPath: 'ReclamacoesAcesso',
    isPrivate: false,
    redirectPath: process.env.REACT_APP_NOVO_PORTAL_URL || '/',
  },
  {
    id: generateRouteID('criarconta'),
    path: '/reclamacoes/criar-conta',
    elementPath: 'CriarConta',
    isPrivate: false,
    redirectPath: process.env.REACT_APP_NOVO_PORTAL_URL || '/',
  },
  {
    id: generateRouteID('criarconta'),
    path: '/reclamacoes/criar-conta',
    elementPath: 'CriarConta',
    isPrivate: false,
    redirectPath: process.env.REACT_APP_NOVO_PORTAL_URL || '/',
  },
  {
    id: generateRouteID('dashboard'),
    path: '/reclamacoes/dashboard',
    elementPath: 'Dashboard',
    isPrivate: true,
    redirectPath: process.env.REACT_APP_NOVO_PORTAL_URL || '/',
  },
  {
    id: generateRouteID('meus-dados'),
    path: '/reclamacoes/meus-dados',
    elementPath: 'MeusDados',
    isPrivate: true,
    redirectPath: process.env.REACT_APP_NOVO_PORTAL_URL || '/',
  },
  {
    id: generateRouteID('novareclamacao'),
    path: '/reclamacoes/nova-reclamacao',
    elementPath: 'NovaReclamacao',
    isPrivate: true,
    redirectPath: process.env.REACT_APP_NOVO_PORTAL_URL || '/',
  },
  {
    id: generateRouteID('detalhesDaReclamacao'),
    path: '/reclamacoes/detalhes',
    elementPath: 'DetalhesDaReclamacao',
    isPrivate: true,
    redirectPath: process.env.REACT_APP_NOVO_PORTAL_URL || '/',
  },
  {
    id: generateRouteID('FaleConoscoReCaptcha'),
    path: '/fale-conosco',
    elementPath: 'FaleConoscoReCaptcha',
    isPrivate: false,
    redirectPath: process.env.REACT_APP_NOVO_PORTAL_URL || '/',
  },
  {
    id: generateRouteID('faleConoscoOpcoes'),
    path: '/fale-conosco/opcoes',
    elementPath: 'FaleConoscoOpcoes',
    isPrivate: true,
    redirectPath: process.env.REACT_APP_NOVO_PORTAL_URL || '/',
  },
  {
    id: generateRouteID('faleConoscoDuvidas'),
    path: '/fale-conosco/duvidas',
    elementPath: 'FaleConoscoDuvidas',
    isPrivate: true,
    redirectPath: process.env.REACT_APP_NOVO_PORTAL_URL || '/',
  },
  {
    id: generateRouteID('FaleConoscoSugestoes'),
    path: '/fale-conosco/sugestoes',
    elementPath: 'FaleConoscoSugestoes',
    isPrivate: true,
    redirectPath: process.env.REACT_APP_NOVO_PORTAL_URL || '/',
  },
  {
    id: generateRouteID('CanalDeDenunciasReCaptcha'),
    path: '/canal-de-denuncias',
    elementPath: 'CanalDeDenunciasReCaptcha',
    isPrivate: false,
    redirectPath: process.env.REACT_APP_NOVO_PORTAL_URL || '/',
  },
  {
    id: generateRouteID('CanalDeDenunciasFormulario'),
    path: '/canal-de-denuncias/formulario',
    elementPath: 'CanalDeDenunciasFormulario',
    isPrivate: true,
    redirectPath: process.env.REACT_APP_NOVO_PORTAL_URL || '/',
  },
];
